import { useFiltersState, useFiltersV2Actions } from "PFApp/components/filters_v2";
import { ScrollablePageWrapper } from "PFApp/components/scrollable_page_wrapper";
import { Card } from "PFComponents/card";
import { EmptyState } from "PFComponents/empty_state";
import TooManyFiltersIllustration from "PFTheme/graphics/illustrations/illustration-too-many-filters.svg";
import { useTranslation } from "react-i18next";

import { useProfilesPageContext } from "./context";
import { ProfilesCards } from "./parts/profiles_cards";
import { ProfilesHeader } from "./parts/profiles_header";
import { ProfilesTable } from "./parts/profiles_table";
import css from "./profiles_page.module.scss";
import { ViewMode } from "./profiles_page.types";

export const ProfilesPage = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "list" });
  const { isFetching, profiles, viewMode, scrollableContainerRef } = useProfilesPageContext();
  const { resetFilters } = useFiltersV2Actions();
  const { areFiltersDefaultOrEmpty } = useFiltersState();

  return (
    <ScrollablePageWrapper ref={scrollableContainerRef}>
      <div className={css.root}>
        <ProfilesHeader />
        {profiles.length === 0 && !isFetching && (
          <Card paddingVariant="xl">
            <EmptyState
              title={t("noItems")}
              illustration={<TooManyFiltersIllustration />}
              onButtonClick={areFiltersDefaultOrEmpty ? undefined : resetFilters}
            />
          </Card>
        )}
        {profiles.length > 0 && viewMode === ViewMode.Cards && <ProfilesCards />}
        {profiles.length > 0 && viewMode === ViewMode.Table && <ProfilesTable />}
      </div>
    </ScrollablePageWrapper>
  );
};
